import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import ButtonBase from '../../Buttons/ButtonBase';

const styles = () => ({
  TextField: {
    maxWidth: 536,
    '@media screen and (max-width: 400px)': {
      maxWidth: 312,
      width: 312,
    }
  },
  TextField_small: {
    maxWidth: '144px',
    marginRight: '24px',
  },
  Grid: {
    marginTop: 39,
  },
  input_icon: {
    maxWidth: '560px'
  },
  ButtonBase: {
    '& button': {
      '@media screen and (max-width: 400px)': {
        minWidth: 144,
      }
    }
  }
});

const VideoForm = props => {

  const {
    // dirty,
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    touched,
    errors,
    isValid,
    classes,
    evento,
  } = props;

  const handleCancel = (event) => {
    event.preventDefault();
    evento()
  };

  return (
    <form style={{margin:0}}>
      <Grid
        container
        direction="column"
        justify="center"
      >
        <TextField
          label="URL de Videos"
          type="text"
          id="youtube"
          variant="outlined"
          classes={{ root: classes.TextField }}
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.youtube}
          fullWidth
          helperText={touched.youtube && errors.youtube ? errors.youtube : ''}
          error={touched.youtube && errors.youtube ? true : false}
        />

        <div className="addLawyers_horizontal-layout" style={{ marginTop: 15 }}>
          <ButtonBase
            type="submit"
            onClick={handleSubmit}
            variant="primary"
            disabled={!isValid}
            classes={{ root: classes.ButtonBase }}
            linkStyle={classes.linkStyle}
            style={{ marginRight: 16, marginBottom: 16 }}
          >
            Agregar
          </ButtonBase>

          <ButtonBase
            type="submit"
            onClick={handleCancel}
            variant="primarySolidOutlined"
            linkStyle={classes.linkStyle}
            // disabled={!isValid}
            classes={{ root: classes.ButtonBase }}
          >
            Cancelar
          </ButtonBase>
        </div>
      </Grid>
    </form >
  );
};

export default withStyles(styles)(VideoForm);
